import { signal } from '@angular/core';

/**
 * Generic in-module view store for single-URL workflow shells.
 * Angular Router enters the module once; subsequent navigation uses signals.
 */
export class WorkflowModuleViewState<TView extends string, TParams extends object> {
  readonly view = signal<TView>('list' as TView);
  readonly params = signal<TParams>({} as TParams);

  setView(view: TView, params: Partial<TParams> = {}): void {
    this.view.set(view);
    this.params.set({ ...this.params(), ...params } as TParams);
  }

  replaceView(view: TView, params: TParams): void {
    this.view.set(view);
    this.params.set(params);
  }

  patchParams(params: Partial<TParams>): void {
    this.params.set({ ...this.params(), ...params } as TParams);
  }
}
